import React, { useEffect, useState } from 'react'
import { Button, Col, CustomInput, Form, FormGroup, Input, Label, Row, Table, UncontrolledTooltip } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import Proxies from '../../components/proxies'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FormField from 'Components/formField'
import CollapsibleCard from 'Components/collapsibleCard'
import { fetchShops, fetchShopProducts } from 'Reducers/actions/cmsActions'
import { toast } from 'react-toastify'
import { Redirect } from 'react-router-dom'
import { StyledDropdown } from '../campaigns/SantanderCampaignUserSelect'

const StyledCustomInput = styled(CustomInput)`
  top: 6px !important;
`

const CountdownForm = props => {
  const dispatch = useDispatch()
  const [countDownDetails, setCountDownDetails] = useState({})
  const [languages, setLanguages] = useState([])
  const [countDownData, setCountDownData] = useState([{}])
  const [brands, setBrands] = useState([])
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState('LOADING')
  const [manufacturers, setManufacturers] = useState([])
  const [allProducts, setAllProducts] = useState([])
  const [products, setProducts] = useState([])

  const { CountdownID } = props.match.params

  const brandShops = useSelector(state => state.cms.brandShops)
  const shopCategories = useSelector(state => state.cms.shopCategories)

  function getLanguages(BrandIDs) {
    if (!BrandIDs || !BrandIDs.length) return
    Proxies.GET('brands/brand-languages', { BrandIDs }).then(responseJSON => {
      if (!responseJSON.error) {
        setLanguages(responseJSON)
      }
    })
  }

  const fetchBrands = () => {
    Proxies.GET('brands/getAssociatedBrands').then(responseJSON => {
      if (responseJSON.error) return setBrands([])
      let allbrands = responseJSON.map(item => ({ BrandID: item.BrandID, brandName: item.brandName }))
      allbrands.sort((a, b) => a.brandName.localeCompare(b.brandName))
      setBrands(allbrands)
    })
  }

  const handleChange = e => {
    setCountDownDetails({
      ...countDownDetails,
      [e.target.name]:
        e.target.type === 'checkbox' || e.target.type === 'radio'
          ? e.target.checked
          : e.target.type === 'number' || e.target.type === 'select-one'
          ? Number(e.target.value)
          : e.target.value
    })
  }

  const updateBrands = item => {
    let selectedBrand = brands.map(brand => {
      if (Number(brand.BrandID) === Number(item.value)) brand.checked = item.checked
      return brand
    })
    setBrands(selectedBrand)
    let BrandIDs = selectedBrand.filter(e => !!e.checked).map(e => e.BrandID)
    handleChange({ target: { name: 'BrandIDs', value: BrandIDs } })
  }

  const uploadLoginImageURL = data => {
    let file = data.target.files[0]
    Proxies.uploadImage(file).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        handleChange({ target: { value: responseJSON.imageOriginSource ? responseJSON.imageOriginSource : '', name: 'imageUrl' } })
      }
    })
  }

  const fetchCountdown = () => {
    setLoading(true)
    Proxies.GET('Countdowns/fetch', { CountdownID }).then(responseJSON => {
      if (!responseJSON.error) {
        setCountDownDetails(responseJSON)
        setCountDownData(responseJSON.translations.length ? responseJSON.translations : [{ title: '', LanguageID: '', content: '' }])
        !!responseJSON && !!responseJSON.BrandIDs && !!responseJSON.BrandIDs.length && getLanguages(responseJSON.BrandIDs)
      }
    })
  }

  const replaceCountdown = () => {
    Proxies.POST(`Countdowns/replace`, {
      ...countDownDetails,
      translations: countDownData,
      title: countDownData[0].title || '',
      description: countDownData[0].description
    }).then(responseJSON => {
      if (responseJSON.error) {
        return toast.error('Action failed', {
          autoClose: 7000
        })
      }
      toast.success('Countdown updated successfully', {
        autoClose: 7000
      })
      if (responseJSON.omittedBrandIDs && responseJSON.omittedBrandIDs.length) {
        toast.warn(`BrandIDs ${responseJSON.omittedBrandIDs.join(', ')} have been omitted as they are already associated with another countdown`, {
          autoClose: 7000
        })
      }
      setStatus('SUCCESS')
    })
  }

  const submitCountdown = () => {
    Proxies.POST(`Countdowns/saveMultiple`, [
      { ...countDownDetails, translations: countDownData, title: countDownData[0].title || '', description: countDownData[0].description }
    ]).then(responseJSON => {
      if (responseJSON.error) {
        return toast.error('Action failed', {
          autoClose: 7000
        })
      }
      toast.success('Countdown created successfully', {
        autoClose: 7000
      })
      if (responseJSON.omittedBrandIDs && responseJSON.omittedBrandIDs.length) {
        toast.warn(`BrandIDs ${responseJSON.omittedBrandIDs.join(', ')} have been omitted as they are already associated with another countdown`, {
          autoClose: 7000
        })
      }
      setStatus('SUCCESS')
    })
  }

  const fetchAllProducts = () => {
    setLoading(true)
    Proxies.GET('products/pool').then(responseJSON => {
      setAllProducts(responseJSON)
      setLoading(false)
    })
  }

  const fetchProductManufacturer = CategoryName => {
    setManufacturers(
      allProducts
        .filter(item => {
          if (item.product === CategoryName) {
            return item
          }
        })
        .map(item => item.manufacturer !== null && item.manufacturer)
        .filter((x, i, a) => {
          return a.indexOf(x) === i
        })
    )
  }

  const fetchProducts = CategoryName => {
    setProducts(
      allProducts.filter(item => {
        if (item.product === CategoryName) {
          return item
        }
      })
    )
  }

  useEffect(() => {
    if (!!CountdownID && allProducts.length > 0) {
      fetchProductManufacturer(countDownDetails.category)
      fetchProducts(countDownDetails.category, countDownDetails.manufacturer)
    }
  }, [allProducts])

  useEffect(() => {
    dispatch(fetchShops())
    fetchBrands()
    fetchAllProducts()
    if (CountdownID) {
      fetchCountdown()
    }
  }, [])

  const editBrandIDS = item => {
    let selectedBrand = brands.map(brand => {
      for (let i = 0; i < item?.length; i++) {
        if (Number(brand.BrandID) === Number(item[i])) {
          brand.checked = true
          break
        }
      }
      return brand
    })
    let BrandIDs = selectedBrand.filter(e => !!e.checked).map(e => e.BrandID)
    handleChange({ target: { name: 'BrandIDs', value: BrandIDs } })
  }

  useEffect(() => {
    if (!!CountdownID && brands.length > 0) {
      return editBrandIDS(countDownDetails.BrandIDs)
    }
    getLanguages(countDownDetails.BrandIDs)
  }, [brands])

  useEffect(() => {
    if (countDownDetails.ShopID) {
      dispatch(fetchShopProducts(countDownDetails.ShopID))
    }
  }, [countDownDetails.ShopID])

  if (status === 'SUCCESS') {
    return <Redirect to='/countdown' />
  }

  return loading ? (
    <FontAwesomeIcon icon='spinner' spin />
  ) : (
    <CollapsibleCard startOpen header={<strong>Nedtælling</strong>}>
      <Button
        className='float-right'
        onClick={() => {
          setCountDownData([
            ...countDownData,
            {
              LanguageID: '',
              title: '',
              description: ''
            }
          ])
        }}
      >
        <FontAwesomeIcon icon='plus' />
      </Button>
      <Form
        onSubmit={e => {
          e.preventDefault()
        }}
      >
        <FormGroup row>
          <Label for='isCountdown' xs={3}>
            Count Down
          </Label>
          <Col sm={9}>
            <StyledCustomInput
              type='switch'
              checked={countDownDetails.isCountdown === 1 ? true : false}
              id='isCountdown'
              name='isCountdown'
              onChange={e => handleChange({ target: { name: 'isCountdown', value: e.target.checked, type: 'number' } })}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col xs='3'>
              <Label for='BrandID'> Brands </Label>
            </Col>
            <Col xs='9'>
              <StyledDropdown
                required={true}
                data={
                  !brands.length
                    ? {}
                    : {
                        label: 'All',
                        value: 'all',
                        expanded: true,
                        children: brands.map(item => ({
                          label: `${item.BrandID} - ${item.brandName}`,
                          value: item.BrandID,
                          checked: item.checked
                        }))
                      }
                }
                onChange={item => updateBrands(item)}
                keepTreeOnSearch={true}
                keepChildrenOnSearch={true}
                showPartiallySelected={true}
                texts={{
                  placeholder: !brands.length ? 'Ingen brand fundet' : 'Vælg brand',
                  noMatches: 'Ingen brand fundet',
                  labelRemove: 'Fjern'
                }}
              />
            </Col>
          </Row>
        </FormGroup>
        {!!countDownData &&
          !!countDownData.length &&
          countDownData.map((event, idx) => (
            <CountDownMultiple
              key={idx}
              idx={idx}
              event={event}
              languages={languages}
              countDownData={countDownData}
              setCountDownData={setCountDownData}
            />
          ))}
        <FormGroup row>
          <Label for='image' sm={3}>
            Image{' '}
            <span>
              <FontAwesomeIcon icon='info-circle' id='countDownImageTooltip' style={{ color: 'blue' }} />
              <UncontrolledTooltip target='countDownImageTooltip'>Best Size for Image: 1440 x 600 </UncontrolledTooltip>
            </span>
          </Label>
          <Col sm={9}>
            <Input
              name='imageUrl'
              field='upload'
              type='file'
              data={{ upload: '' }}
              onChange={e => {
                uploadLoginImageURL(e)
              }}
              accept='image/*'
            />
            <img
              draggable='false'
              src={countDownDetails.imageUrl}
              alt={countDownDetails.imageUrl}
              style={{
                height: '100px',
                width: '100px',
                objectFit: 'cover',
                marginTop: '10px',
                marginBottom: '10px',
                display: countDownDetails.imageUrl ? 'inline-block' : 'none'
              }}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for='countDownBannerImage' sm={3}>
            Image Size
          </Label>
          <Col sm={9}>
            <Row>
              <Col sm={6}>
                <Input
                  type='number'
                  name='imageHeight'
                  id='imageHeight'
                  value={countDownDetails.imageHeight ? countDownDetails.imageHeight : 0}
                  onChange={handleChange}
                  placeholder='Height in px'
                />
              </Col>
              <Col sm={6}>
                <Input
                  type='number'
                  name='imageWidth'
                  id='imageWidth'
                  value={countDownDetails.imageWidth ? countDownDetails.imageWidth : 0}
                  onChange={handleChange}
                  placeholder='Width in px'
                />
              </Col>
            </Row>
          </Col>
        </FormGroup>
        <FormField name='Count Down till date' field='endDate' type='datetime-local' data={countDownDetails} onChange={handleChange} />
        <FormGroup row>
          <Label for='highlightedProductShop' sm={3}>
            Shop
          </Label>
          <Col sm={9}>
            <Input
              id='checked_shopCategory'
              name='buttonTitle'
              type='radio'
              checked={countDownDetails.buttonTitle === 'Se udvalget' ? true : false}
              onChange={() => handleChange({ target: { name: 'buttonTitle', checked: 'Se udvalget', type: 'radio' } })}
            />
            <CustomInput type='select' id='ShopID' name='ShopID' value={countDownDetails.ShopID || ''} onChange={handleChange}>
              <option value=''>Select shop</option>
              {brandShops.map((shop, i) => {
                return (
                  <option value={Number(shop.ShopID)} key={i}>
                    {`${shop.moduleName} - ${shop.ShopID}`}
                  </option>
                )
              })}
            </CustomInput>
          </Col>
        </FormGroup>

        {/* Category */}
        <FormGroup row>
          <Label for='category' sm={3}>
            Category
          </Label>
          <Col sm={9}>
            <CustomInput
              type='select'
              id='category'
              name='category'
              value={countDownDetails.category ? countDownDetails.category : ''}
              onChange={e => {
                fetchProductManufacturer(e.target.value)
                handleChange({ target: { name: 'category', value: e.target.value } })
                fetchProducts(e.target.value)
              }}
            >
              <option value=''>Select Category</option>
              {shopCategories.map((category, i) => {
                return (
                  <option value={category.categoryName} key={i}>
                    {`${category.categoryName} - ${category.CategoryID}`}
                  </option>
                )
              })}
            </CustomInput>
          </Col>
        </FormGroup>
        {/* Manufacturer */}
        {!!countDownDetails.category && (!countDownDetails.ProductID || countDownDetails.ProductID === null) && (
          <FormGroup row>
            <Label for='manufacturer' sm={3}>
              Product Brand
            </Label>
            <Col sm={9}>
              <Input
                className={countDownDetails.manufacturer ? 'is-valid' : 'is-invalid'}
                required
                type='select'
                id='manufacturer'
                name='manufacturer'
                value={countDownDetails.manufacturer ? countDownDetails.manufacturer : ''}
                onChange={e => {
                  handleChange({ target: { name: 'manufacturer', value: e.target.value !== 'Select Brand' ? e.target.value : null } })
                }}
              >
                <option value={null}>Select Brand</option>
                {manufacturers.map((manufacturer, i) => {
                  return (
                    <option value={manufacturer} key={i}>
                      {`${manufacturer}`}
                    </option>
                  )
                })}
              </Input>
            </Col>
          </FormGroup>
        )}

        {/* PRODUCT */}
        {!!countDownDetails.category && (!countDownDetails.manufacturer || countDownDetails.manufacturer === null) && (
          <FormGroup row>
            <Label for='ProductID' sm={3}>
              Product
            </Label>
            <Col sm={9}>
              <Input
                className={countDownDetails.ProductID ? 'is-valid' : 'is-invalid'}
                required
                type='select'
                id='ProductID'
                name='ProductID'
                value={countDownDetails.ProductID ? countDownDetails.ProductID : ''}
                onChange={handleChange}
              >
                <option value=''>Select product</option>
                {products.map((product, i) => {
                  return (
                    <option value={product.ProductID} key={i}>
                      {`${product.ProductID} - ${product.elementTitle} - ${product.productStatus}`}
                    </option>
                  )
                })}
              </Input>
            </Col>
          </FormGroup>
        )}
        <FormGroup row>
          <Label for='countDownCompetition' sm={3}>
            Competition
          </Label>
          <Col sm={9}>
            <Input
              id='checked_competition'
              name='buttonTitle'
              type='radio'
              checked={countDownDetails.buttonTitle === 'Se konkurrencen' ? true : false}
              onChange={() => handleChange({ target: { name: 'buttonTitle', checked: 'Se konkurrencen', type: 'radio' } })}
            />
            <Input
              type='number'
              name='CompetitionID'
              id='CompetitionID'
              value={countDownDetails.CompetitionID ? countDownDetails.CompetitionID : ''}
              onChange={handleChange}
              placeholder='Competition ID'
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for='countDownNews' sm={3}>
            News
          </Label>
          <Col sm={9}>
            <Input
              id='checked_News'
              name='buttonTitle'
              type='radio'
              checked={countDownDetails.buttonTitle === 'Se nyheden' ? true : false}
              onChange={() => handleChange({ target: { name: 'buttonTitle', checked: 'Se nyheden', type: 'radio' } })}
            />
            <Input
              type='number'
              name='PostID'
              id='PostID'
              value={countDownDetails.PostID ? countDownDetails.PostID : ''}
              onChange={handleChange}
              placeholder='News Post ID'
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for='countDownTextColor' sm={3}>
            Count Down Text Color
          </Label>
          <Col sm={3}>
            <Col sm={7} style={{ display: 'flex', gap: '20px' }}>
              <Label for='textColorWhite'>White</Label>
              <Input
                id='textColorWhite'
                name='textColor'
                type='checkbox'
                checked={countDownDetails.textColor === 'white' ? true : false}
                onChange={e => handleChange({ target: { name: 'textColor', value: e.target.checked ? 'white' : 'black' } })}
              />
            </Col>
            <Col sm={7} style={{ display: 'flex', gap: '20px' }}>
              <Label for='textColorBlack'> Black</Label>
              <Input
                id='textColorBlack'
                name='textColor'
                type='checkbox'
                checked={countDownDetails.textColor === 'black' ? true : false}
                onChange={e => handleChange({ target: { name: 'textColor', value: e.target.checked ? 'black' : 'white' } })}
              />
            </Col>
          </Col>
        </FormGroup>
        <Button
          onClick={() => {
            CountdownID ? replaceCountdown() : submitCountdown()
          }}
        >
          Gem
        </Button>
      </Form>
    </CollapsibleCard>
  )
}

function CountDownMultiple(props) {
  const { idx, languages, countDownData, setCountDownData, event } = props

  return (
    <Table style={{ borderBottom: '1px solid #e8e8e8' }}>
      <FormGroup row>
        <Label for='LanguageID' sm={3}>
          Language
        </Label>
        <Col>
          <Input
            className={event.LanguageID ? 'is-valid' : 'is-invalid'}
            required
            type='select'
            name='LanguageID'
            value={event.LanguageID ? event.LanguageID : ''}
            id='LanguageID'
            onChange={e => {
              let newCountdownData = [...countDownData]
              newCountdownData[idx]['LanguageID'] = Number(e.target.value)
              setCountDownData(newCountdownData)
            }}
          >
            <option value=''>Click to Select</option>
            {languages.map((lan, i) => {
              return (
                <option value={lan.LanguageID} key={i}>
                  {`${lan.languageKey} - ${lan.languageName}`}
                </option>
              )
            })}
          </Input>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for='title' sm={3}>
          {' '}
          Title
        </Label>
        <Col>
          <Input
            required
            id='title'
            className={event.title ? 'is-valid' : 'is-invalid'}
            value={event.title ? event.title : ''}
            name='title'
            onChange={e => {
              let newCountdownData = [...countDownData]
              newCountdownData[idx]['title'] = e.target.value
              setCountDownData(newCountdownData)
            }}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for='description' sm={3}>
          Description
        </Label>
        <Col>
          <Input
            required
            type='textarea'
            maxLength={250}
            id='description'
            className={event.description ? 'is-valid' : 'is-invalid'}
            value={event.description ? event.description : ''}
            name='description'
            onChange={e => {
              let newCountdownData = [...countDownData]
              newCountdownData[idx]['description'] = e.target.value
              setCountDownData(newCountdownData)
            }}
          />
        </Col>
      </FormGroup>
    </Table>
  )
}

export default CountdownForm
